import { render } from "./CasualPayrollDetails.vue?vue&type=template&id=f6604a98&scoped=true"
import script from "./CasualPayrollDetails.vue?vue&type=script&lang=js"
export * from "./CasualPayrollDetails.vue?vue&type=script&lang=js"

import "./CasualPayrollDetails.vue?vue&type=style&index=0&id=f6604a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6604a98"]])

export default __exports__